<template>
    <section id="home" class="section welcome-area bg-overlay overflow-hidden d-flex align-items-center">
        <div class="container">
            <div class="row align-items-center">
                <!-- Welcome Intro Start -->
                <div class="col-12 col-md-7">
                    <div class="welcome-intro">
                        <h1 class="text-white">VM Partners</h1>
                        <p class="text-white-50 my-4">
                          VM Partners je kompanija za konsalting u oblasti procene vrednosti imovine. Tokom desetogodišnje profesionalne karijere učestvovali smo u izradi preko 5.000 izveštaja o proceni vrednosti. Poslujemo u kancelarijama u Beogradu, Novom Sadu i Leskovcu. Prepoznali smo važnost digitalizacije i održivog razvoja, s toga aktivno razvijamo AVM i usavršavamo se na polju zelene gradnje i zelene energije.
                        </p>
                        <!-- Buttons -->
                        <div class="button-group">
                            <a href="tel:+381653400331" class="btn btn-bordered-white active">Pozovite nas</a>
                            <a href="mailto:office@vmpartners.rs" class="btn btn-bordered-white d-none d-sm-inline-block">Pošaljite nam upit</a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-5">
                    <!-- Welcome Thumb -->
                    <div class="welcome-thumb-wrapper mt-5 mt-md-0">
                        <span class="welcome-thumb-1">
                            <img class="d-block ml-auto" src="assets/img/welcome_thumb_12.png" alt="">
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>
